import Button from "components/Form/Button"
import { useLang } from "hooks/useLang"
import { AiOutlineMinus, AiOutlinePlus } from "react-icons/ai"
import { twMerge } from "tailwind-merge"

interface Props {
    onIncrease?: (e: React.MouseEvent) => void
    onDecrease?: (e: React.MouseEvent) => void
    decreaseDisabled?: boolean
    increaseDisabled?: boolean
    quantity: number
    waitlistActions: {
        showWaitlistButtons: boolean
        setShowWaitlistButtons: (value: boolean) => void
    }
}

const WaitlistSelect = ({
    onDecrease,
    onIncrease,
    decreaseDisabled,
    increaseDisabled,
    quantity,
    waitlistActions,
}: Props) => {
    const { t } = useLang()

    const baseButtonClass =
        "outline-none border-none w-7 h-7 lg:w-9 lg:h-9 text-white rounded-full flex items-center justify-center cursor-pointer"

    const disabledButtonClass =
        "bg-mint-green-500 bg-opacity-20 cursor-not-allowed hover:bg-mint-green-500 hover:bg-opacity-20"

    const enabledButtonClass = "bg-mint-green-500 hover:bg-mint-green-700"

    return (
        <div className="flex flex-col gap-2 items-center">
            {/* {!waitlistActions.showWaitlistButtons ? (
                <Button
                    className={"px-4 py-1 capitalize text-xsn bg-[#FE4A36]"}
                    onClick={() => {
                        waitlistActions.setShowWaitlistButtons(true)
                    }}
                    // disabled={ticketCount === 0}
                >
                    {t("join_waitlist")}
                </Button>
            ) : null} */}

            {/* {waitlistActions.showWaitlistButtons ? ( */}
            <div className="flex items-center gap-x-2 lg:gap-x-5">
                <Button
                    onClick={onDecrease}
                    theme="custom"
                    className={twMerge(
                        baseButtonClass,
                        decreaseDisabled
                            ? disabledButtonClass
                            : enabledButtonClass
                    )}
                >
                    <AiOutlineMinus className="text-white font-bold" />
                </Button>
                <span className="text-black font-bold w-4 text-center">
                    {quantity}
                </span>
                <Button
                    onClick={onIncrease}
                    theme="custom"
                    className={twMerge(
                        baseButtonClass,
                        increaseDisabled
                            ? disabledButtonClass
                            : enabledButtonClass
                    )}
                >
                    <AiOutlinePlus className="text-white font-bold" />
                </Button>
            </div>
            {/* ) : null} */}
        </div>
    )
}

export default WaitlistSelect
